import React from 'react';
import '../styles/FiscalSponsorship.css';
import { FaRocket, FaHandshake, FaChartLine } from 'react-icons/fa';

const FiscalSponsorship = () => {
  const features = [
    {
      icon: <FaRocket />,
      title: "Launch Faster",
      description: "Skip the lengthy and expensive process of forming your own nonprofit. Start accepting tax-deductible donations immediately under our 501(c)(3) umbrella."
    },
    {
      icon: <FaHandshake />,
      title: "Full Support",
      description: "Focus on your mission while we handle the administrative complexities. From legal compliance to financial management, we've got you covered."
    },
    {
      icon: <FaChartLine />,
      title: "Scale With Confidence",
      description: "Access professional tools and support to grow your impact. Our platform provides everything needed to expand your reach and effectiveness."
    }
  ];

  return (
    <section className="fiscal-sponsorship">
      <div className="content-container">
        <div className="text-section">
          <h2>What is Fiscal Sponsorship?</h2>
          <p className="intro-text">
            Fiscal sponsorship is a powerful launch pad for charitable initiatives, 
            enabling you to make an immediate impact without the burden of establishing 
            and maintaining a separate nonprofit organization.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FiscalSponsorship;
